import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterStateUrl } from '@sd-portal/shared/util';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import { auditLogSelectors } from '../shared-audit.adapters';
import { State } from '..';
import * as fromExpense from './expense.reducer';

// feature selectors
const getSharedAuditState = createFeatureSelector<State>('sharedAudit');
const getRouterState = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

// router param selector
export const getExpenseId = createSelector(getRouterState, state => +state.state.params['id']);

// feature slice - expense
const getExpenseSubState = createSelector(getSharedAuditState, state => state.expense);

// expense slices
const getExpenseCategoryTypeState = createSelector(
  getExpenseSubState,
  state => state.expenseCategoryTypes
);
const getExpenseSkeletonState = createSelector(getExpenseSubState, state => state.expenseSkeleton);
const getDeletedExpenseSkeletonState = createSelector(
  getExpenseSubState,
  state => state.deletedExpenseSkeletons
);
const getExpenseAuditState = createSelector(getExpenseSubState, state => state.expenseAudit);

// expense category types
const getExpenseCategoryTypes = createSelector(
  getExpenseCategoryTypeState,
  fromExpense.expenseCategoryTypeSelectors.selectAll
);
export const getExpenseCategoryTypeName = (expenseCategoryTypeId: number) =>
  createSelector(getExpenseCategoryTypes, (expenseCategoryTypes: RefTypeItem[]) =>
    expenseCategoryTypes.find(ect => ect.id === expenseCategoryTypeId)
  );

// skeletons
export const getExpenseSkeletonLoading = createSelector(
  getExpenseSkeletonState,
  state => state.loading
);
export const getExpenseSkeletonLoaded = createSelector(
  getExpenseSkeletonState,
  state => state.loaded
);
export const getExpenseSkeleton = createSelector(
  getExpenseSkeletonState,
  fromExpense.expenseSkeletonSelectors.selectAll
);

export const getDeletedExpenseSkeletonsLoading = createSelector(
  getDeletedExpenseSkeletonState,
  state => state.loading
);
export const getDeletedExpenseSkeletonsLoaded = createSelector(
  getDeletedExpenseSkeletonState,
  state => state.loaded
);
export const getDeletedExpenseSkeletons = createSelector(
  getDeletedExpenseSkeletonState,
  fromExpense.deletedExpenseSkeletonSelectors.selectAll
);

// posted flight audit
export const getExpenseAuditLoading = createSelector(getExpenseAuditState, state => state.loading);
export const getExpenseAuditLoaded = createSelector(getExpenseAuditState, state => state.loaded);
export const getExpenseAudit = createSelector(getExpenseAuditState, auditLogSelectors.selectAll);
